import ReportsAdapter from './base';

export default class Rubric extends ReportsAdapter {
  modelNamePlural = 'rubrics';
}
